import clsx from 'clsx';
import { Fragment, type ReactNode } from 'react';

export interface KeyValuePopoverRow {
  label: string;
  value: ReactNode;
  valueClassName?: string;
}

interface KeyValuePopoverGridProps {
  rows: KeyValuePopoverRow[];
}

/** Label/value rows for Popover content — readable in light and dark mode. */
export function KeyValuePopoverGrid({ rows }: KeyValuePopoverGridProps) {
  return (
    <div className="grid grid-cols-2 gap-x-3 gap-y-2">
      {rows.map((row) => (
        <Fragment key={row.label}>
          <span className="text-gray-dark text-right text-sm font-medium">{row.label}</span>
          <span className={clsx('text-blue-dark text-left text-sm', row.valueClassName)}>
            {row.value}
          </span>
        </Fragment>
      ))}
    </div>
  );
}

export default KeyValuePopoverGrid;
